const { useEffect } = wp.element;

const Style = ({ attributes, setAttributes }) => {
  const { uniqueId, width, height, posterHeight, align, CSS } = attributes;

  useEffect(() => {
    const playerWidth = typeof width === "object" ? `${width.number}${width.unit}` : width;
    const playerHeight = typeof height === "object" ? `${height.number}${height.unit}` : height;
    const playerPosterHeight = typeof posterHeight === "object" ? `${posterHeight.number}${posterHeight.unit}` : posterHeight;

    const CSS = `#${uniqueId} {justify-content: ${align}}#${uniqueId} .bluePlaylist {overflow: hidden;width: ${playerWidth}; height: ${playerHeight};max-width: 100%;max-height: ${playerHeight}}#${uniqueId} .right{height: ${playerHeight}}#${uniqueId} .bluePlaylist .left img {height: ${playerPosterHeight}}`;

    setAttributes({ CSS });
  }, [uniqueId, width, height, posterHeight, align]);

  return <style>{CSS}</style>;
};

export default Style;
